/// <reference path="../global.d.ts" />

import flatpickr from "flatpickr";

import { Utils } from "../../include/utils";


export class SelectorFechas {

    utils = new Utils();

    instance_fechas: any = undefined;

    /** Objeto fecha */
    fechas_range: any = undefined;
    horai: any = undefined;
    horaf: any = undefined;

    /** Identificadores inputs flatpickr que reaccionan al cambio de fecha */
    id_fecha_i_flatpickr: string = 'fechai-recogida';
    id_fecha_f_flatpickr: string = 'fechaf-devolucion';

    /** Identificadores de inputs hidden que guardan el valor de las fechas seleccionadas */
    id_fecha_ini: string = 'fecha-ini';
    id_fecha_fin: string = 'fecha-fin';

    id_hora_ini: string = 'hora-ini';
    id_hora_fin: string = 'hora-fin';

    instanceDate() {
        let self = this;
        let $elemento_ini: any = $('#' + this.id_fecha_i_flatpickr);
        let $elemento_fin: any = $('#' + this.id_fecha_f_flatpickr);
        let $horaField = $('#' + this.id_hora_ini);
        let $horaFieldFin = $('#' + this.id_hora_fin);
        let $fecha_field_ini = $('#' + this.id_fecha_ini);
        let $fecha_field_fin = $('#' + this.id_fecha_fin);
        const $cajas = $elemento_ini.closest('.fecha-hora-container').add($elemento_fin.closest('.fecha-hora-container'));

        const min_date = this.getMinDate();

        // Un solo calendario para las dos fechas; solo se cierra con la X, Esc o un clic afuera. Cada clic
        // cambia una fecha sin borrar la otra (ver elegir()). Los días antes de hoy están deshabilitados (minDate).
        let editando: 'ini' | 'fin' = 'ini';
        let actuales: Date[] = []; // fechas antes del clic (flatpickr ya las cambió cuando llega a onChange)
        let ultimoRango: Date[] = []; // última recogida+devolución completa: se repone si se cierra a medias
        let mesVisto = 0, quitarAnimacion: any, cajaCal: HTMLElement;

        const dia = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
        const marcar = (campo: 'ini' | 'fin') => {
            editando = campo;
            const $caja = (campo == 'ini' ? $elemento_ini : $elemento_fin).closest('.fecha-hora-container');
            $cajas.not($caja).removeClass('editando');
            $caja.addClass('editando');
            return $caja.get(0);
        };
        // Alineado al borde derecho del campo que se edita (si se pasa a hacer clic en el otro campo, se desliza)
        const colocar = (caja: HTMLElement) => {
            cajaCal = caja;
            fecha._positionCalendar(caja);
            const r = caja.getBoundingClientRect(), ancho = fecha.calendarContainer.offsetWidth;
            const derecha = Math.min(document.body.offsetWidth - window.pageXOffset - r.right, document.body.offsetWidth - ancho - 16);
            $(fecha.calendarContainer).css({ left: 'auto', right: Math.max(0, derecha) + 'px' });
        };
        const escribir = (fechas: Date[]) => {
            if (fechas[0]) {
                $elemento_ini.val(self.formatDateToCustomString(fechas[0], alk_lang));
                $fecha_field_ini.val(setDateFormat(fechas[0]));
            }
            if (fechas[1]) {
                $elemento_fin.val(self.formatDateToCustomString(fechas[1], alk_lang));
                $fecha_field_fin.val(setDateFormat(fechas[1]));
            } else {
                $elemento_fin.val(''); // esperando la devolución
            }
        };
        // Qué fechas quedan al hacer clic en un día:
        // - Editando la recogida: el día es la recogida; la devolución se queda si sigue siendo posterior.
        // - Editando la devolución: antes de la recogida cambia la recogida; ese mismo día o después cambia la
        //   devolución (se puede devolver el mismo día, como antes y como en el móvil).
        const elegir = (d: Date): Date[] => {
            const [ini, fin] = actuales;
            if (editando == 'ini' || !ini) return fin && dia(d) < dia(fin) ? [d, fin] : [d];
            if (dia(d) < dia(ini)) return fin ? [d, fin] : [d];
            return [ini, d];
        };
        const abrir = (campo: 'ini' | 'fin', tipoHora = 0) => {
            const yaAbierto = fecha.isOpen;
            if (!yaAbierto) {
                actuales = fecha.selectedDates.slice();
                ultimoRango = actuales.length == 2 ? actuales : [];
                fecha.jumpToDate(actuales[0] || min_date);
                mesVisto = fecha.currentYear * 12 + fecha.currentMonth;
            }
            const caja = marcar(campo);
            $(fecha.calendarContainer).removeClass('cerrando');
            self.closeTimepickr(fecha, false);
            if (tipoHora) self.openTimepickr(tipoHora, fecha, tipoHora == 1 ? $horaField : $horaFieldFin, true);
            if (!yaAbierto) fecha.open(undefined, caja);
            colocar(caja);
        };

        let optiones: any = {
            showMonths: 2,
            dateFormat: 'd/M/y',
            minDate: min_date,
            maxDate: null,
            mode: "range",
            ariaDateFormat: 'd/m/Y',
            disableMobile: false,
            time_24hr: false,
            position: "below", // siempre debajo del campo, como antes
            clickOpens: false,
            closeOnSelect: false,
            ignoredFocusElements: [$elemento_fin.get(0), $horaField.get(0), $horaFieldFin.get(0)],
            weekdays: (date: any, format: any) => {
                return date.toLocaleDateString("es", { weekday: "short" }).charAt(0);
            },
            onReady: function (selectedDates: any, dateStr: any, instance: any) {
                mesVisto = instance.currentYear * 12 + instance.currentMonth;
                $(`<button type="button" class="fp-cerrar" aria-label="${alk_lang == 'en' ? 'Close' : 'Cerrar'}"><svg viewBox="0 0 14 14"><path d="M1 1l12 12M13 1L1 13"/></svg></button>`)
                    .on('click', () => instance.close())
                    .appendTo(instance.calendarContainer);
            },
            onValueUpdate: function (selectedDates: Date[]) {
                escribir(selectedDates);
            },
            onChange: function (selectedDates: Date[], dateStr: any, instance: any) {
                if (!instance.isOpen) return;
                // flatpickr ya aplicó su regla (con 2 fechas, el 3er clic borra todo): se reemplaza por elegir().
                // Sin setDate: salta al mes de la devolución y movería los meses que se están viendo.
                const nuevas = elegir(instance.latestSelectedDateObj);
                const cambioRecogida = !actuales[0] || dia(nuevas[0]) != dia(actuales[0]);
                actuales = nuevas;
                instance.selectedDates = nuevas.slice();
                instance.redraw();
                escribir(nuevas);
                if (nuevas.length == 2) ultimoRango = nuevas;
                marcar('fin'); // después de cualquier clic, el siguiente ajusta la devolución
                colocar(cajaCal); // flatpickr lo reubica al limpiar el rango: se deshace (no se mueve bajo el mouse)
                if (cambioRecogida && self.compareDate(nuevas[0], min_date)) self.openTimepickr(1, instance, $horaField);
            },
            onMonthChange: function (selectedDates: any, dateStr: any, instance: any) {
                const mes = instance.currentYear * 12 + instance.currentMonth;
                const $dias = $(instance.daysContainer);
                $dias.removeClass('fp-next fp-prev').addClass(mes > mesVisto ? 'fp-next' : 'fp-prev');
                mesVisto = mes;
                clearTimeout(quitarAnimacion);
                quitarAnimacion = setTimeout(() => $dias.removeClass('fp-next fp-prev'), 250);
            },
            onDayCreate: function (dObj: any, dStr: any, fp: any, dayElem: any) {
                let id_pais = 1;

                switch (alk_lang) {
                    case 'es':
                        id_pais = 1;
                        break;
                    case 'en':
                        id_pais = 1;
                        break;
                    case 'es-mx':
                        id_pais = 29
                        break;
                    default:
                        break;
                }
                //if (fp.element.dataset.id_pais == undefined) return false
                // Solo agrega los estilos para las fechas festivas si es una búsqueda en Colombia.	
                const $dayElem = $(dayElem);
                let fecha = $dayElem.attr('aria-label');
                let festivos_ms = self.obtenerFestivos(id_pais);
                for (let festivo of festivos_ms) {
                    if (fecha == festivo.date) {
                        $dayElem.addClass('festivo').attr('title', festivo.name)
                        break
                    }
                }
            },
            onClose: function (selectedDates: Date[], dateStr: any, instance: any) {
                $cajas.removeClass('editando');
                // Se cerró a medias (clic afuera, Esc): conserva la recogida nueva y la duración que había
                if (selectedDates.length < 2 && ultimoRango.length == 2) {
                    const ini = selectedDates[0] || ultimoRango[0];
                    let fin = ultimoRango[1];
                    if (dia(fin) < dia(ini)) fin = new Date(ini.getTime() + (ultimoRango[1].getTime() - ultimoRango[0].getTime()));
                    instance.setDate([ini, fin], true); // true: actualiza los campos (onChange no hace nada con el calendario cerrado)
                }
                // flatpickr la oculta de golpe: se deja visible 150 ms para que salga con la animación
                const $cal = $(instance.calendarContainer).addClass('cerrando');
                setTimeout(() => { if (instance.isOpen) return; $cal.removeClass('cerrando'); self.closeTimepickr(instance, false); }, 150);
            }
        };

        this.setLocale(optiones);

        let fecha: any = flatpickr($elemento_ini.get(0), optiones);
        this.instance_fechas = fecha;
        this.fechas_range = fecha;
        this.horai = $horaField;
        this.horaf = $horaFieldFin;

        ([[$elemento_ini, 'ini', 0], [$elemento_fin, 'fin', 0], [$horaField, 'ini', 1], [$horaFieldFin, 'fin', 2]] as any[]).forEach(([$campo, campo, tipoHora]) => {
            $campo.on('click', () => abrir(campo, tipoHora));
            $campo.on('keydown', (e: any) => { if (e.key == 'Enter' || e.key == ' ') { e.preventDefault(); abrir(campo, tipoHora); } });
        });

        return fecha
    }

    public formatDateToCustomString(date: Date, language: string) {
        const day = date.getDate().toString().padStart(2, '0');
        let monthNames;

        if (language === 'es' || language === 'es-mx') {
            monthNames = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
        } else if (language === 'en') {
            monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        }
        else {
            throw new Error('Unsupported language');
        }
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        const formattedDate = `${day}/${monthNames[monthIndex]}/${year}`;
        return formattedDate;
    }

    /**
     * Método para agregar los lenguajes del selector
     * @param options 
     */
    private setLocale(options: any) {
        if (alk_lang == 'es' || alk_lang === 'es-mx') {
            options.locale = {
                firstDayOfWeek: 1,
                weekdays: {
                    shorthand: ["D", "L", "M", "M", "J", "V", "S"]
                },
                months: {
                    shorthand: [
                        "Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
                    ],
                    longhand: [
                        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                    ],
                },
            };
        } else {
            options.locale = {
                firstDayOfWeek: 1,
                weekdays: {
                    shorthand: ["S", "M", "T", "W", "T", "F", "S"]
                }
            };
        }
    }


    private closeTimepickr(instance: any, cerrarFlatpickr: any = true) {
        const $flatpickr_calendar = $(instance.calendarContainer)
        if (cerrarFlatpickr) {
            instance.close();
        }

        let $timepicker_content = $flatpickr_calendar.find('.timepicker-content')
        $timepicker_content.remove()
        $flatpickr_calendar.find('.flatpickr-months').show()
        $flatpickr_calendar.find('.flatpickr-innerContainer').show()
        $flatpickr_calendar.css('width', '800px')
        $('.flatpickr-days').css('width', '100%')


        $flatpickr_calendar.removeClass('time')
    }

    private obtenerFestivos(idPais: any) {
        if (festivos == undefined) return [];
        if (festivos[idPais] == undefined) return [];
        let festivos_ms = []
        for (let i in festivos[idPais]) {
            let festivo = festivos[idPais][i]
            festivos_ms.push({
                name: festivo.nombFest,
                date: festivo.diaFest
            })
        }
        return festivos_ms;
    }


    /** cerrarAlElegir: abierto desde el campo de hora → al elegir la hora cierra; abierto solo (recogida hoy) → vuelve a los días */
    private openTimepickr(tipo: any, instance: any, $inputHora: any, cerrarAlElegir = false) {

        let self = this;
        const $flatpickr_calendar = $(instance.calendarContainer);

        let $timepicker_content = $flatpickr_calendar.find('.timepicker-content')

        $flatpickr_calendar.find('.flatpickr-months').hide();
        $flatpickr_calendar.find('.flatpickr-innerContainer').hide();
        $flatpickr_calendar.addClass('time');

        if (!$timepicker_content.length) {
            $timepicker_content = this.renderTimepickr(tipo);
            $flatpickr_calendar.append($timepicker_content);

            $timepicker_content.find('.volver').one('click', function () {
                $timepicker_content.remove()
                $flatpickr_calendar.find('.flatpickr-months').show()
                $flatpickr_calendar.find('.flatpickr-innerContainer').show()
                $flatpickr_calendar.removeClass('time')
            })

            $timepicker_content.find('.time').on('click', 'span:not(.disabled)', function (event) {
                event.stopPropagation()
                let $this = $(this),
                    hora_seleccionada = $this.text();
                $inputHora.val(hora_seleccionada);

                if (tipo == 1) {
                    self.horaf.val(self.horai.val())
                }
                self.closeTimepickr(instance, cerrarAlElegir && instance.selectedDates.length == 2)
            });
        }

        const currentDate = new Date();
        currentDate.setHours(currentDate.getHours() + 1);
        if (tipo == 1 && self.compareDate(instance.selectedDates[0], currentDate)) {
            const hours = currentDate.getHours().toString().padStart(2, '0');
            const minutes = currentDate.getMinutes().toString().padStart(2, '0');
            const time = `${hours}:${minutes}`;

            let new_time = '';
            $timepicker_content.find('.time span').each(function () {
                const $this = $(this);
                if ($this.text() <= time) $this.addClass('disabled');
                else {
                    if (new_time === '') new_time = $this.text();
                }
            });
            if (new_time !== '' && $inputHora.val() < time)
                $inputHora.val(new_time);
        }

        $timepicker_content.find(`.time span:contains("${$inputHora.val()}")`).addClass('selected')
        $timepicker_content.show();

        $('.flatpickr-calendar').css('width', '400px');
    }

    private renderTimepickr(tipo = 1) {
        return $(`<div class="timepicker-content">
                    <p class="timepicker-head bold">${tipo == 1 ? x_textos['553-0'] : x_textos['2236-1']}</p>
                    <div class="timepicker-cbody">
                        <div class="timepicker-body">
                            <p class="timepicker-title bold">${x_textos['554-0']}</p>
                            <div class="time">
                                <span>00:00</span>
                                <span>00:30</span>
                                <span>01:00</span>
                                <span>01:30</span>
                                <span>02:00</span>
                                <span>02:30</span>
                                <span>03:00</span>
                                <span>03:30</span>
                                <span>04:00</span>
                                <span>04:30</span>
                                <span>05:00</span>
                                <span>05:30</span>
                            </div>
                        </div>
                        <div class="timepicker-body">
                            <p class="timepicker-title bold">${x_textos['554-1']}</p>
                            <div class="time">
                                <span>06:00</span>
                                <span>06:30</span>
                                <span>07:00</span>
                                <span>07:30</span>
                                <span>08:00</span>
                                <span>08:30</span>
                                <span>09:00</span>
                                <span>09:30</span>
                                <span>10:00</span>
                                <span>10:30</span>
                                <span>11:00</span>
                                <span>11:30</span>
                                <span>12:00</span>
                                <span>12:30</span>
                                <span>13:00</span>
                                <span>13:30</span>
                                <span>14:00</span>
                                <span>14:30</span>
                                <span>15:00</span>
                                <span>15:30</span>
                                <span>16:00</span>
                                <span>16:30</span>
                                <span>17:00</span>
                                <span>17:30</span>
                            </div>
                        </div>
                        <div class="timepicker-body">
                            <p class="timepicker-title bold">${x_textos['555-0']}</p>
                            <div class="time">
                                <span>18:00</span>
                                <span>18:30</span>
                                <span>19:00</span>
                                <span>19:30</span>
                                <span>20:00</span>
                                <span>20:30</span>
                                <span>21:00</span>
                                <span>21:30</span>
                                <span>22:00</span>
                                <span>22:30</span>
                                <span>23:00</span>
                                <span>23:30</span>
                            </div>
                        </div>								
                    </div>							
                </div>`);
    }

    private getMinDate() {
        // Obtener la fecha actual
        let currentDate = new Date();
        currentDate.setHours(currentDate.getHours() + 1, currentDate.getMinutes() + 30);
        currentDate.setHours(0, 0, 0, 0);
        return currentDate;
    }

    /**
     * Método para asignar los valores iniciales 
     * Se almacenan en una cookie y se guardan en un atributo data de los inputs de fechas
     */
    public setValoresInicialesSelector() {
        let fecha_ini = new Date($('#' + this.id_fecha_i_flatpickr).data('val').replace(/-/g, "/"));
        let fecha_fin = new Date($('#' + this.id_fecha_f_flatpickr).data('val').replace(/-/g, "/"));
        let $elemento_ini: any = $('#' + this.id_fecha_i_flatpickr);
        let $elemento_fin: any = $('#' + this.id_fecha_f_flatpickr);
        let fecha_actual = new Date();

        if (fecha_ini < fecha_actual) {
            this.utils.sendMsjModal(x_textos["2349-1"], x_textos['2349-0'], false, x_textos['R256-0'], () => {
                window.location.href = alk_lang == 'es' ? '/' : '/' + alk_lang; // Redirige a la página de inicio
            }, undefined, false, false, "bg-warning");
        }

        this.instance_fechas.setDate([fecha_ini, fecha_fin], true);

        $elemento_ini.val(this.formatDateToCustomString(fecha_ini, alk_lang));
        $elemento_fin.val(this.formatDateToCustomString(fecha_fin, alk_lang));
    }

    compareDate(date1: Date, date2: Date) {
        return (
            date1?.getDate() === date2?.getDate() &&
            date1?.getMonth() === date2?.getMonth() &&
            date1?.getFullYear() === date2?.getFullYear()
        );
    }
}

export function setDateFormat(date: Date): string {
    if (!date || isNaN(date.getTime()))
        return '--/--/----';
    const day = date.getDate().toString().padStart(2, '0');
    const mount = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${mount}/${year}`;
}